import React, { createContext, useContext, useState, useEffect } from "react";

const LandingContext = createContext({
    showLanding: false,
    setShowLanding: () => {},
});

const isMobileView = () => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 768;
};

export const LandingProvider = ({ children }) => {
    const [showLanding, setShowLanding] = useState(() => {
        if (isMobileView()) {
            try {
                sessionStorage.setItem("hasVisitedLanding", "true");
            } catch (e) {
                // ignore storage access errors
            }
            return false;
        }
        const hasVisited = sessionStorage.getItem("hasVisitedLanding");
        return !hasVisited;
    });

    useEffect(() => {
        const handleResize = () => {
            if (isMobileView()) {
                setShowLanding(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <LandingContext.Provider value={{ showLanding, setShowLanding }}>
            {children}
        </LandingContext.Provider>
    );
};

export const useLanding = () => useContext(LandingContext);

